/**
 * apps/web/src/pages/BacktestsPage.tsx
 * -------------------------------------------------------
 * Purpose:
 *   Placeholder UI for running backtests.
 *
 * High-level data flow:
 *   - In a future iteration, this page would:
 *       1) POST a backtest run request
 *       2) stream progress / poll for results
 *       3) show drilldowns by confusion matrix cell
 *   - For now, it's a static page to keep routing stable while the backend evolves.
 */

import React from 'react';
import { Card, Stack, Text, Title } from '@mantine/core';

export function BacktestsPage(): React.ReactElement {
  return (
    <Card withBorder radius="md">
      <Stack gap="sm">
        <Title order={3}>Backtests</Title>
        <Text c="dimmed">
          Backtest execution is not implemented in this starter monolith yet.
          The UI scaffold is here so you can add endpoints + RR actions without redoing routing.
        </Text>
      </Stack>
    </Card>
  );
}
